import React from "react"


export const BottomNav = ()=>{

    return <nav className="bottom_nav">
        <ul>
            <li>
                1D
            </li>
            <li>
                5D
            </li>
            <li>
              1M
            </li>
            <li>
                3M
            </li>
            <li>
                6M
            </li>
            <li>
                YTD
            </li>
            <li>1Y</li>
            <li>5Y</li>
            <li>All</li>
        </ul>
        <ul>

        </ul>
    </nav>
}